import { Component, OnInit } from '@angular/core';
import { MainService } from 'src/app/services/main/main.service';

@Component({
  selector: 'app-support-instant',
  templateUrl: './support-instant.component.html',
  styleUrls: ['./support-instant.component.scss']
})
export class SupportInstantComponent implements OnInit {

  constructor(public mainService: MainService) { }

  ngOnInit() {
    this.showSupportedDebitCard();
  }

  searchDebitBank;
  showSupportedDebitCard() {
    let data = {
      access_token: localStorage.getItem('token'),
      offset: 0,
      limit: 6000,
      search_string: ''
    }
    this.mainService.api(data, 'instant_payout_support_bank_list', true)
      .subscribe((data: any) => {
        if (data.is_error == 0) {
          this.banks = data.data;
          this.getFilteredInstantPayoutSupoortBanks('');
        }
      });
  }

  banks = [];
  filtered_banks;
  filtered_banks_count;
  offset = 99;
  getFilteredInstantPayoutSupoortBanks(search_string) {
    let filtered_banks = this.banks.filter(bank => bank.card_name.toLowerCase().indexOf(search_string.trim().toLowerCase()) !== -1);
    this.filtered_banks_count = filtered_banks.length;
    this.filtered_banks = filtered_banks;
  }
}
